import {Component} from '@angular/core';
import {TableControlComponent, TableControlModule} from "frontier";
import ControlGuids from "../../../api/ControlGuids";

@Component({
  selector: 'app-client-hnr-import-table',
  standalone: true,
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  imports: [TableControlModule],
  providers: [
    {provide: TableControlComponent, useExisting: ClientHnrImportTableComponent},
  ],
})
export class ClientHnrImportTableComponent extends TableControlComponent {
  override GUID: string = ControlGuids.TClientTableHnr;
}
